export enum ProductSubCategory {
	MOBILTELEFONER = "Mobiltelefoner",
	GOD_SOM_NY = "God Som Ny",
	SMARTKLOKKER = "Smartklokker",
	NETTBRETT = "Nettbrett",
	RUTER = "Ruter",
	SUBSCRIPTION = "Abonnement",
	TELEFONNUMMER = "Telefonnummer",
	SERVICES = "Forsikring",
	OTHER = "Annet", // Default fallback
}
